import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { defaultOrgConfig } from './default';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const directcareai: OrganizationSettings = defaultOrgConfig(
  'directcareai', // or directcare
  'Direct Care AI',
  'directcare.ai'
);

const excludedStates = {
  WV: true,
  KS: true,
  NM: true,
  OTHER: true
};

directcareai.patientWebAppLayout.availableStates.us =
  directcareai.patientWebAppLayout.availableStates.us.filter(
    ({ code }) => !excludedStates[code]
  );

directcareai.patientWebAppLayout.nmiPublicKey = 'V8B3pN-P2dsXS-e68fb4-yGuc8z';
directcareai.patientWebAppLayout.logo.img =
  'https://cdn.prod.website-files.com/67603a0a15dbb9e21dd86b2b/676085a92d1653e4afc7e77b_DC%20logo%20long%20trans-p-500.png';
directcareai.patientWebAppLayout.privacyPolicyUrl =
  'https://www.directcare.ai/privacy-policy';
directcareai.patientWebAppLayout.termsOfUseUrl =
  'https://www.directcare.ai/terms-and-conditions';
directcareai.crmWebAppLayout.logo =
  'https://cdn.prod.website-files.com/67603a0a15dbb9e21dd86b2b/67619ae9cc41d9e0060d37b1_favicon.png';
directcareai.emrWebAppLayout.logo =
  'https://cdn.prod.website-files.com/67603a0a15dbb9e21dd86b2b/67619ae9cc41d9e0060d37b1_favicon.png';

directcareai.patientWebAppLayout.colors = {
  primaryColor: '#853fad',
  secondaryColor: '#00c05a'
};

directcareai.emrWebAppLayout.customerTabs = [
  'sheet',
  'consults',
  'subscriptions',
  'notes',
  'files',
  'rx',
  'credits',
  'payment-methods',
  'orders',
  'coupons',
  'extras',
  'activity'
];
directcareai.patientWebAppLayout.shopUrl = 'https://www.directcare.ai';
directcareai.patientWebAppLayout.mainMenu.push({
  title: 'Subscriptions',
  link: PATIENT_WEB_PAGES_URLS.subscriptions.list,
  svg: 'assets/icons/orders.svg',
  roles: ['*']
});

directcareai.crmWebAppLayout.mainMenu = [
  {
    title: 'Leads',
    link: CRM_WEB_PAGES_URLS.leads.list,
    icon: 'fa-regular fa-address-book',
    roles: ['*']
  },

  {
    title: 'Tasks',
    link: CRM_WEB_PAGES_URLS.tasks.list,
    icon: 'fa-solid fa-list-check',
    roles: ['*']
  },
  {
    title: 'Segments',
    link: CRM_WEB_PAGES_URLS.segment.list,
    icon: 'fa-solid fa-table-columns',
    roles: ['*']
  },
  {
    title: 'Store Manager',
    link: '',
    icon: 'fas fa-shop',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Products',
        link: CRM_WEB_PAGES_URLS.products.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Categories',
        link: CRM_WEB_PAGES_URLS.productCategories.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Coupons',
        link: CRM_WEB_PAGES_URLS.coupons.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Promotions',
        link: CRM_WEB_PAGES_URLS.promotions.list,
        icon: 'fas fa-product'
      }
    ]
  },
  {
    title: 'Admin',
    link: '',
    icon: 'fas fa-user-cog',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Workflows',
        link: CRM_WEB_PAGES_URLS.workflows.list,
        icon: 'fas fa-code-branch'
      },
      {
        title: 'Templates',
        link: CRM_WEB_PAGES_URLS.emailTemplates.list,
        icon: 'fas fa-palette'
      },
      {
        title: 'Users',
        link: CRM_WEB_PAGES_URLS.users.list,
        icon: 'fas fa-lock'
      },
      {
        title: 'Settings',
        link: CRM_WEB_PAGES_URLS.settings.base,
        icon: 'fa-solid fa-sliders'
      }
    ]
  }
];

// directCareAI.patientWebAppLayout.nmiPublicKey = 'Unavailable';
directcareai.emrWebAppLayout.questionnaires = [
  'facesheet',
  'facesheet_ext',
  'selfie',
  'govId',
  'bodySelfie',
  'wlus',
  'wlusmonthly',
  'edBeluga',
  'edBelugaMonthly',
  'menHairLoss',
  'hairLossFollowup',
  'peBeluga',
  'peBelugaMonthly',
  'antiAgingBeluga',
  'antiAgingBelugaFollowup',
  'libidoBeluga'
];
delete directcareai.pharmacies.Foothills;
delete directcareai.pharmacies.Promise;
directcareai.pharmacies.pharmacyHub.states =
  directcareai.pharmacies.pharmacyHub.states.filter(
    val => !excludedStates[val]
  );
